module.exports = __webpack_public_path__ + "assets/img/login-v2-dark.0e3cda65.svg";